/**
 * @generated SignedSource<<d40a07da1ac32e8761b7bd72112fdd7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type profileProfileQuestionsQuery$variables = {};
export type profileProfileQuestionsQuery$data = {
  readonly profileQuestions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly question: string;
        readonly translationKey: string;
        readonly practitionerType: string;
      } | null;
    } | null> | null;
  };
};
export type profileProfileQuestionsQuery = {
  variables: profileProfileQuestionsQuery$variables;
  response: profileProfileQuestionsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      }
    ],
    "concreteType": "ProfileQuestionConnection",
    "kind": "LinkedField",
    "name": "profileQuestions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileQuestionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileQuestion",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "question",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "translationKey",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "practitionerType",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "profileQuestions(first:10)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "profileProfileQuestionsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "profileProfileQuestionsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "199bd66e56fe37d3a1a6e11b3274ac1e",
    "id": null,
    "metadata": {},
    "name": "profileProfileQuestionsQuery",
    "operationKind": "query",
    "text": "query profileProfileQuestionsQuery {\n  profileQuestions(first: 10) {\n    edges {\n      node {\n        id\n        question\n        translationKey\n        practitionerType\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "eb29921cf47bd0af1cafc77dc3be7c2b";

export default node;
